import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
import { OtpInput } from './ui/OtpInput';
interface OTPVerificationProps {
  phone: string;
  onVerify: () => void;
  onBack: () => void;
}
export function OTPVerification({
  phone,
  onVerify,
  onBack
}: OTPVerificationProps) {
  const [otp, setOtp] = useState<string[]>(['', '', '', '', '', '']);
  const [timer, setTimer] = useState(30);
  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => setTimer(t => t - 1), 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);
  const isComplete = otp.every(digit => digit !== '');
  return <div className="space-y-6" data-id="element-677">
      <div data-id="element-678">
        <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-679">
          Check your phone
        </h1>
        <p className="text-gray-600" data-id="element-680">
          We've sent a 6-digit code to{' '}
          <span className="font-semibold text-gray-900" data-id="element-681">
            +60 {phone.replace(/^0+/, '')}
          </span>
        </p>
        <button onClick={onBack} className="text-sm font-semibold text-gray-900 underline underline-offset-2 mt-2 hover:text-[#B8860B]" data-id="element-682">
          Change phone number
        </button>
      </div>

      <div className="space-y-8" data-id="element-683">
        <OtpInput value={otp} onChange={setOtp} autoFocus data-id="element-684" />

        <Button onClick={onVerify} fullWidth disabled={!isComplete} data-id="element-685">
          Verify Code
        </Button>

        <div className="text-center" data-id="element-686">
          {timer > 0 ? <p className="text-sm text-gray-600" data-id="element-687">
              Resend code in{' '}
              <span className="font-medium text-gray-900" data-id="element-688">{timer}s</span>
            </p> : <button onClick={() => setTimer(30)} className="text-sm font-semibold text-gray-900 underline underline-offset-2 hover:text-[#B8860B]" data-id="element-689">
              Resend code
            </button>}
        </div>
      </div>
    </div>;
}